import React, { useContext, Fragment } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import { store as mainStore } from '../../../../../store';
import {
  Redirect,
  Switch,
  Route,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Drivers from './Drivers/Drivers';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 500,
    display: 'flex',
    flexDirection: 'column',
    '&>*': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const Import = () => {
  useTitle('ایمپورت گروهی رانندگان')
  const classes = useStyles();
  const {
    state: {
      Auth: {
        profile: { username },
      },
    },
    showMessage,
    showError,
  } = useContext(mainStore);
  const history = useHistory();
  const { pathname } = useLocation();
  const userType = pathname?.includes('drivers') ? `رانندگان` : `مشتریان`;

  return (
    <FullCard title={`ایمپورت گروهی ${userType}`}>
      {username === 'admin' ? (
        <Switch>
          <Route exact path="/protected/admin/users/import">
            <div className={classes.root}>
              <Button
                variant="contained"
                size="large"
                color="secondary"
                onClick={() =>
                  history.push('/protected/admin/users/import/drivers')
                }
              >
                رانندگان
              </Button>
              <Button variant="contained" size="large" color="secondary">
                صاحبین بار
              </Button>
            </div>
          </Route>
          <Route exact path="/protected/admin/users/import/drivers">
            <Drivers />
          </Route>
          <Route exact path="/protected/admin/users/import/customers">
            <div>Customers</div>
          </Route>
        </Switch>
      ) : (
        <Redirect to="/logout" />
      )}
    </FullCard>
  );
};

export default React.memo(Import);
